import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actionTypes from "../ActionTypes";

import {
  saveProgramVideoSuccess,
  saveProgramVideoFailure,
  updateProgramVideoSuccess,
  updateProgramVideoFailure,
  deleteProgramVideoSuccess,
  deleteProgramVideoFailure,
  readProgramVideoSuccess,
  readProgramVideoFailure,
} from "./programVideosActions";

import {
  saveProgramVideo,
  updateProgramVideo,
  deleteProgramVideo,
  readProgramVideos,
} from "./programVideosAPI";

/* SAVE */
function* saveProgramVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
        const res = yield call(saveProgramVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(saveProgramVideoSuccess(res.data));
      toast.success(res.message || "Program Video Saved!");
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (error) {
    yield put(saveProgramVideoFailure(error.message));
    toast.error(error.message);
    action.callback?.({ type: 0, error: error.message });
  }
}

/* UPDATE */
function* updateProgramVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(updateProgramVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(updateProgramVideoSuccess(res.data));
      toast.success(res.message || "Program Video Updated!");
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (error) {
    yield put(updateProgramVideoFailure(error.message));
    toast.error(error.message);
    action.callback?.({ type: 0, error: error.message });
  }
}

/* DELETE */
function* deleteProgramVideoSaga(action) {
  try {
    const res = yield call(deleteProgramVideo, action.payload);

    if (res?.type === 1) {
      yield put(deleteProgramVideoSuccess(action.payload));
      toast.success(res.message || "Program Video Deleted!");
      action.callback?.({ type: 1, data: action.payload });
    } else throw new Error(res.error);
  } catch (error) {
    yield put(deleteProgramVideoFailure(error.message));
    toast.error(error.message);
    action.callback?.({ type: 0, error: error.message });
  }
}

/* READ */
function* readProgramVideosSaga(action) {
  try {
    const res = yield call(readProgramVideos, action.payload);

    if (res?.type === 1) {
      yield put(readProgramVideoSuccess(res.data));
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (error) {
    yield put(readProgramVideoFailure(error.message));
    action.callback?.({ type: 0, error: error.message });
  }
}

/* WATCHER */
export default function* programVideosWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_PROGRAM_VIDEO_REQUEST, saveProgramVideoSaga);
  yield takeLatest(actionTypes.UPDATE_PROGRAM_VIDEO_REQUEST, updateProgramVideoSaga);
  yield takeLatest(actionTypes.DELETE_PROGRAM_VIDEO_REQUEST, deleteProgramVideoSaga);
  yield takeLatest(actionTypes.READ_PROGRAM_VIDEO_REQUEST, readProgramVideosSaga);
}
